export class Storage {
}
Storage.REMOTE_BASE_URL = process.env.MIX_APP_URL;
Storage.RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
// static readonly KENALL_PUBLIC_KEY = process.env.MIX_KENALL_PUBLIC_KEY;
Storage.STRIPE_PUBLIC_KEY = process.env.MIX_STRIPE_PUBLIC_KEY;
Storage.STRIPE_SECRET_KEY = process.env.MIX_STRIPE_SECRET_KEY;
